import { useState } from 'react';
import MatchesMainPage from './MatchesMainPage';
import MatchSettingsDrawer from './MatchSettingsDrawer';
import useOrgLevelAdmin from '../../../../hooks/useOrgLevelAdmin';

/**
 * Program Matches surface for the orgLevelAdmin restructure (Mentorship /
 * Guided Course land here). No sub-tabs — the matches list is the page. A
 * "Settings" CTA next to Export Data opens a right drawer with the match
 * settings (Learning Objectives + matching rules + AI matching). When the flag
 * is off it renders the legacy MatchesMainPage unchanged.
 */
const ProgramMatches = () => {
  const orgLevelAdmin = useOrgLevelAdmin();
  const [settingsOpen, setSettingsOpen] = useState(false);

  if (!orgLevelAdmin) return <MatchesMainPage />;

  return (
    <>
      <MatchesMainPage onOpenSettings={() => setSettingsOpen(true)} />
      <MatchSettingsDrawer open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </>
  );
};

export default ProgramMatches;
